import type { AppEnvironment, RuntimeAppConfig } from './environment.model';

const RUNTIME_SCALAR_KEYS: Array<keyof RuntimeAppConfig> = [
  'apiUrl',
  'platformBillingApiUrl',
  'customerPortalUrl',
  'appUrl',
  'projectMicroLinkBaseUrl',
  'appName',
  'version',
  'logLevel',
  'inactivityTimeout',
  'warningTimeout',
  'sessionExpiryWarningMs',
  'unlayerProjectId',
  'tmsApiUrl',
  'tmsClientPassword',
  'googleMapsApiKey',
  'googleMapsMapId',
  'digilockerAllowLocalhostRedirect',
  'digilockerLocalTunnelUrl',
  'digilockerRedirectUrl',
  'calendarOAuthRedirectUri',
  'microsoftCalendarRedirectUri',
  'googleCalendarClientId',
  'microsoftCalendarClientId',
  'googleCalendarClientSecret',
  'microsoftCalendarClientSecret',
];

function shouldApplyRuntimeValue(value: unknown): boolean {
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  return true;
}

export function applyRuntimeConfig(
  target: AppEnvironment,
  source: RuntimeAppConfig,
): void {
  for (const key of RUNTIME_SCALAR_KEYS) {
    const value = source[key];
    if (shouldApplyRuntimeValue(value)) {
      Object.assign(target, { [key]: value });
    }
  }

  if (source.firebase) {
    const firebase = { ...target.firebase };
    for (const [key, value] of Object.entries(source.firebase)) {
      if (shouldApplyRuntimeValue(value)) {
        Object.assign(firebase, { [key]: value });
      }
    }
    target.firebase = firebase;
  }
}
